
import { defineComponent, onBeforeMount, reactive } from 'vue'
import { useRouter } from 'vue-router'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheSelect from '@/common/components/UI/TheSelect/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

// constants
const COMPANIES_TYPES = [
    { id: 1, name: 'ТОО' },
    { id: 2, name: 'ИП' },
    { id: 3, name: 'АО' }
]

const BUSINESS_MODELS = [
    { id: 1, name: 'B2B' },
    { id: 2, name: 'B2C' }
]

const COUNTRIES = [
    { id: 1, name: 'Республика Казахстан' },
    { id: 2, name: 'Россия' }
]

// realisations
import { deliveryCompanies } from '@/core/realisations/delivery-companies.realisation'

// validation
import useVuelidate from '@vuelidate/core'
import { required, integer, email } from '@vuelidate/validators'
import { incorrectSymbolValidator, binValidator } from '@/common/validators/common.validators'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        PageTitle,
        TheButton,
        TheInput,
        TheSelect,
        FileReader,
    },
    setup() {
        const router = useRouter()
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            //
            name: null as string | null,
            shortName: null as string | null,
            businessModelId: null as number | null,
            bin: null as string | null,
            contactPhone: null as string | null,
            email: null as string | null,
            kbe: null as string | null,
            legalAddress: null as string | null,
            actualAddress: null as string | null,
            bank: null as string | null,
            bik: null as string | null,
            iik: null as string | null,
            vatCertificateNumber: null as string | null,
            vatSeries: null as string | null,
            vatCertificateDate: null as string | null,
            countryId: null as number | null,
            typeId: null as number | null,
            contract: [] as File[]
        })

        const state_form$ = useVuelidate({
            name: { required, incorrectSymbolValidator },
            businessModelId: { required },
            bin: { required, integer, binValidator },
            contactPhone: { required, incorrectSymbolValidator },
            email: { required, email },
            kbe: { required, integer },
            legalAddress: { required, incorrectSymbolValidator },
            actualAddress: { required, incorrectSymbolValidator },
            bank: { required, incorrectSymbolValidator },
            bik: { required, incorrectSymbolValidator },
            iik: { required, incorrectSymbolValidator },
            vatCertificateNumber: { required },
            vatSeries: { required },
            vatCertificateDate: { required },
        }, state)

        const onSubmit = async () => {
            if (state.is_loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const payload = new FormData()
                payload.append('name', state.name as string)
                payload.append('shortName', state.shortName ? state.shortName : '')
                payload.append('businessModelId', (state.businessModelId as number).toString())
                payload.append('bin', state.bin as string)
                payload.append('contactPhone', state.contactPhone as string)
                payload.append('email', state.email as string)
                payload.append('kbe', state.kbe as string)
                payload.append('legalAddress', state.legalAddress as string)
                payload.append('actualAddress', state.actualAddress as string)
                payload.append('bank', state.bank as string)
                payload.append('bik', state.bik as string)
                payload.append('iik', state.iik as string)
                payload.append('vatCertificateNumber', state.vatCertificateNumber as string)
                payload.append('vatSeries', state.vatSeries as string)
                payload.append('vatCertificateDate', state.vatCertificateDate as string)
                payload.append('countryId', state.countryId ? state.countryId.toString() : '')
                payload.append('typeId', state.typeId ? state.typeId.toString() : '')

                if (state.contract.length) {
                    payload.append('contract', state.contract[0])
                }
                
                await deliveryCompanies.createCompany(payload)

                notifications.notify({ title: 'Компания добавлена', type: 'success' })
                router.push('/companies/spark-kz')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При добавлении компании произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            COMPANIES_TYPES,
            BUSINESS_MODELS,
            COUNTRIES,
            state,
            state_form$,
            onSubmit,
        }
    }
})
